import type { FC } from 'react';

/** The asterisk MUI puts after a required label, for labels rendered outside MUI's own. */
export const RequiredMark: FC = () => <span className="MuiFormLabel-asterisk ml-1 text-red-main">*</span>;
